import { render, staticRenderFns } from "./dialog-primary.vue?vue&type=template&id=ee254ab2&scoped=true&"
import script from "./dialog-primary.vue?vue&type=script&lang=js&"
export * from "./dialog-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee254ab2",
  null
  
)

export default component.exports